import {useParams} from 'react-router-dom';

import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {getPollingInterval} from 'shared/api/pollingHelper';

export const useHttpMonitorLogsScreen = () => {
    const {monitorId} = useParams<{monitorId: string}>();
    const {data: monitor} = httpMonitorAPI.useGetHttpMonitorQuery(monitorId ?? '', {
        skip: !monitorId,
        pollingInterval: getPollingInterval(),
    });

    return {monitor, isNotFound: !monitorId};
};

export default useHttpMonitorLogsScreen;
